import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getSupportChats,
    getSupportMessages,
    sendSupportMessage,
    setSelectedChat,
} from "../../redux/support/supportSlice";
import { getImageUrlHelper } from "../../helper/helper";
import Avatar from "../../components/Avtar/Avatar";

const SupportLayer = () => {
    const dispatch = useDispatch();

    const { chats = [], messages = [], selectedChatId } =
        useSelector((state) => state.support || {});

    const user = JSON.parse(localStorage.getItem("user"));

    const [message, setMessage] = useState("");

    const chatRef = useRef();

    useEffect(() => {
        dispatch(getSupportChats({ page: 1, limit: 20 }));
    }, []);

    useEffect(() => {
        if (selectedChatId) {
            dispatch(
                getSupportMessages({
                    chatId: selectedChatId,
                    page: 1,
                    limit: 50,
                })
            );
        }
    }, [selectedChatId]);

    useEffect(() => {
        chatRef.current?.scrollTo({
            top: chatRef.current.scrollHeight,
            behavior: "smooth",
        });
    }, [messages]);

    const selectedChat = chats.find((c) => c.id === selectedChatId);

    const handleSend = (e) => {
        e.preventDefault();

        if (!message.trim() || !selectedChatId) return;

        dispatch(
            sendSupportMessage({
                message,
                supportChatId: selectedChatId,
            })
        );

        setMessage("");
    };
    const handleGlobalRefresh = () => {
        // Refresh chat list
        dispatch(getSupportChats({ page: 1, limit: 20 }));

        // Refresh messages if chat selected
        if (selectedChatId) {
            dispatch(
                getSupportMessages({
                    chatId: selectedChatId,
                    page: 1,
                    limit: 50,
                })
            );
        }
    };

    const getLastMessage = (chatId) => {
        const chatMsgs = messages.filter(
            (m) => m.supportChatId === chatId
        );

        const last = chatMsgs[chatMsgs.length - 1];

        if (!last) return "No messages";

        return last.messageText.length > 30
            ? last.messageText.slice(0, 30) + "..."
            : last.messageText;
    };

    const adminId = user?.id;

    return (
        <div className="chat-wrapper">

            <div className="chat-sidebar card">

                <div className="chat-sidebar-single top-profile d-flex align-items-center gap-2">
                    <Avatar
                        name={user.fullName}
                        image={user.profilePicture}
                        uniqueKey={user.id}
                        size={28}
                    />
                    <div>
                        <h6 className="mb-0">{user?.fullName || "Admin"}</h6>
                        <small className="text-success">Online</small>
                    </div>

                    <button
                        onClick={handleGlobalRefresh}
                        className="refresh-btn ms-auto"
                    >
                        <Icon icon="solar:refresh-bold-duotone" />
                    </button>
                </div>

                {/* <div className="chat-search">
                    <span className="icon">
                        <Icon icon="iconoir:search" />
                    </span>
                    <input type="text" placeholder="Search..." />
                </div> */}

                <div className="chat-all-list">

                    {chats.map((chat) => (
                        <div
                            key={chat.id}
                            onClick={() => dispatch(setSelectedChat(chat.id))}
                            className="chat-sidebar-single d-flex align-items-center gap-2"
                            style={{
                                cursor: "pointer",
                                background:
                                    selectedChatId === chat.id ? "#e7f1ff" : "",
                                borderLeft:
                                    selectedChatId === chat.id
                                        ? "4px solid #0d6efd"
                                        : "",
                            }}
                        >

                            <Avatar
                                name={chat.user.fullName}
                                image={chat.user.profilePicture}
                                uniqueKey={chat.user.id}
                                size={28}
                            />

                            <div className="flex-grow-1">
                                <h6 className="mb-0 text-sm">
                                    {chat.user?.fullName}
                                </h6>

                                <small className="text-muted">
                                    {getLastMessage(chat.id)}
                                </small>
                            </div>

                            <div className="text-end">
                                <small className="text-muted">
                                    {new Date(chat.updatedAt).toLocaleTimeString([], {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                    })}
                                </small>

                                {chat.pending && (
                                    <div><span className="badge bg-success rounded-circle d-flex align-items-center justify-content-center" style={{ width: 22, height: 22 }}>
                                        1
                                    </span></div>

                                )}
                            </div>
                        </div>
                    ))}

                </div>
            </div>

            <div className="chat-main card d-flex flex-column">

                {!selectedChat ? (
                    <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ height: "100%" }}
                    >
                        <Icon icon="mdi:chat-outline" width="60" className="mb-3 text-muted" />
                        <h6 className="text-muted">Select chat to respond</h6>
                        <p className="text-xs text-secondary">
                            Choose a conversation from the left panel
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="d-flex align-items-center gap-2 border-bottom p-3">

                            <Avatar
                                name={selectedChat.user?.fullName}
                                image={selectedChat.user?.profilePicture}
                                uniqueKey={selectedChat.user?.id}
                                size={28}
                            />

                            <div>
                                <h6 className="mb-0">{selectedChat.user?.fullName}</h6>
                                <small className="text-success">Active</small>
                            </div>

                        </div>

                        <div
                            className="chat-message-list p-3"
                            ref={chatRef}
                            style={{ overflowY: "auto", flex: 1 }}
                        >
                            {messages.length === 0 ? (
                                <div className="text-center mt-5 text-muted">
                                    No messages yet
                                </div>
                            ) : (
                                messages.map((msg) => {
                                    const isAdmin = msg.senderId === adminId;

                                    return (
                                        <div
                                            key={msg.id}
                                            className={`d-flex mb-3 ${isAdmin ? "justify-content-end" : "justify-content-start"}`}
                                        >
                                            {/* LEFT SIDE (Receiver) */}
                                            {!isAdmin && (
                                                <Avatar
                                                    name={msg.sender?.fullName}
                                                    image={msg.sender?.profilePicture}
                                                    uniqueKey={msg.sender?.id}
                                                    size={32}
                                                />
                                            )}

                                            {/* MESSAGE BODY */}
                                            <div
                                                style={{
                                                    maxWidth: "65%",
                                                    marginLeft: isAdmin ? "0" : "8px",
                                                    marginRight: isAdmin ? "8px" : "0",
                                                }}
                                            >
                                                {/* NAME (like WhatsApp) */}
                                                <div style={{ fontSize: "11px", fontWeight: 600, marginBottom: "2px" }}>
                                                    {msg.sender?.fullName}
                                                </div>

                                                {/* MESSAGE BUBBLE */}
                                                <div
                                                    style={{
                                                        background: isAdmin ? "#dcf8c6" : "#ffffff",
                                                        padding: "8px 12px",
                                                        borderRadius: "10px",
                                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                    }}
                                                >
                                                    <p style={{ margin: 0, fontSize: "13px" }}>
                                                        {msg.messageText}
                                                    </p>

                                                    {/* TIME (separate row FIXES breaking issue) */}
                                                    <div
                                                        style={{
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            color: "#667781",
                                                            marginTop: "4px",
                                                        }}
                                                    >
                                                        {new Date(msg.createdAt).toLocaleTimeString([], {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        })}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* RIGHT SIDE (Sender / Admin) */}
                                            {isAdmin && (
                                                <Avatar
                                                    name={msg.sender?.fullName}
                                                    image={msg.sender?.profilePicture}
                                                    uniqueKey={msg.sender?.id}
                                                    size={32}
                                                />
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>

                        <div className="p-3 border-top">

                            <form
                                onSubmit={handleSend}
                                className="d-flex align-items-center gap-2"
                            >

                                <div
                                    className="d-flex align-items-center flex-grow-1 px-3"
                                    style={{
                                        border: "1px solid #e5e7eb",
                                        borderRadius: "12px",
                                        height: "45px",
                                        background: "#f9fafb",
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder="Write message"
                                        className="border-0 w-100 bg-transparent"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        style={{ outline: "none" }}
                                    />

                                </div>

                                <button
                                    type="submit"
                                    className="btn btn-primary btn-sm d-flex align-items-center gap-2"

                                >Send
                                    <Icon icon="f7:paperplane" />
                                </button>

                            </form>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SupportLayer;